import axios from 'axios';
import { API_BASE_URL as BASE_URL } from '../../config/api';

const API_BASE_URL = `${BASE_URL}/api/v1/members`;

export const me = async () => {
  const response = await axios.get(`${API_BASE_URL}/me`);
  // console.log(response.data);
  return response.data;
};

export const changeProfileImage = async (imageId) => {
  const response = await axios.patch(`${API_BASE_URL}/change-image`, {
    imageId: imageId
  });
  return response.data;
};

export const active = async () => {
  const response = await axios.patch(`${API_BASE_URL}/active`, {});
  return response.data;
};

export const changePassword = async (currentPassword, newPassword) => {
  const response = await axios.patch(`${API_BASE_URL}/change-password`, {
    currentPassword,
    newPassword
  });
  return response.data;
};

export const verifyPhoneReverificationCode = async (phone, verificationCode) => {
  const response = await axios.post(`${API_BASE_URL}/phone/verify-reverification-code`, {
    phone,
    verificationCode
  });
  return response.data;
};

export const withdraw = async () => {
  const response = await axios.delete(`${API_BASE_URL}/withdraw`);
  return response.data;
};

export const changeName = async (name) => {
  const response = await axios.patch(`${API_BASE_URL}/change-name`, {
    name
  });
  return response.data;
};

export const deleteProfileImage = async () => {
  const response = await axios.patch(`${API_BASE_URL}/delete-image`, {});
  return response.data;
};

export const evaluatePoint = async (evaluatePointRequest) => {
  const response = await axios.patch(`${API_BASE_URL}/point`, evaluatePointRequest);
  return response.data;
};

export const updateLocation = async (latitude, longitude) => {
  const response = await axios.patch(`${API_BASE_URL}/location`, {
    latitude,
    longitude
  });
  return response.data;
};

export const getDashboardInfo = async () => {
    const { API_BASE_URL } = require('../../config/api');
    const response = await axios.get(`${API_BASE_URL}/api/v1/admin/dashboard`);
  return response.data;
};
